<mat-card class="matp-card">
  <app-shipment-info-list-table
    [shipmentList]="shipmentList"
    [routeLoading]="routeLoading"
    [defaultFilters]="defaultFilters"
    [editableRole]="editableRole"
    [showSensorAlertStartTime]="false"
    (opened)="opened.emit($event)"
    (statusGottenReady)="statusGottenReady.emit($event)"
    (statusInterrupted)="statusInterrupted.emit($event)"
  ></app-shipment-info-list-table>
</mat-card>
